import { render, staticRenderFns } from "./CreateBatchModal.vue?vue&type=template&id=f4e2ef3a&scoped=true"
import script from "./CreateBatchModal.vue?vue&type=script&lang=js"
export * from "./CreateBatchModal.vue?vue&type=script&lang=js"
import style0 from "./CreateBatchModal.vue?vue&type=style&index=0&id=f4e2ef3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e2ef3a",
  null
  
)

export default component.exports